import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initSwiper()
  }

  disconnect() {
    // Clean up swiper instance when the element is removed from the DOM
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      // Responsive breakpoints
      breakpoints: {
        // Mobile (1 slide)
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        // Tablet (2 slides)
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // Desktop (3 slides)
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      },
      
      // Optional parameters
      loop: true,
      grabCursor: true,
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      // Auto height
      autoHeight: true,
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      }
    })
  }
}
